<template>
  <SkeletonLoader>
    <div class="chat-skeleton">
      <div class="chat-skeleton__sidebar">
        <div class="chat-skeleton__search">
          <div class="sk-rect" style="height: 36px; width: 100%;"></div>
        </div>
        <div v-for="i in 5" :key="'room-' + i" class="sk-row">
          <div class="sk-circle sk-circle--lg"></div>
          <div class="sk-col">
            <div class="sk-line" :style="{ width: widths[i][0] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: widths[i][1] }"></div>
          </div>
        </div>
      </div>
      <div class="chat-skeleton__main">
        <div class="chat-skeleton__header sk-row">
          <div class="sk-circle sk-circle--md"></div>
          <div class="sk-col">
            <div class="sk-line" style="width: 30%;"></div>
          </div>
        </div>
        <div class="chat-skeleton__messages">
          <div v-for="i in 6" :key="'msg-' + i" class="chat-skeleton__msg" :class="{ 'chat-skeleton__msg--right': i % 3 === 0 }">
            <div v-if="i % 3 !== 0" class="sk-circle sk-circle--sm"></div>
            <div class="sk-rect" :style="{ width: msgWidths[i][0], height: msgWidths[i][1] }"></div>
          </div>
        </div>
        <div class="chat-skeleton__footer">
          <div class="sk-rect" style="height: 42px; width: 100%; border-radius: 10px;"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'ChatSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      widths: {
        1: ['55%', '75%'],
        2: ['45%', '60%'],
        3: ['65%', '50%'],
        4: ['50%', '80%'],
        5: ['60%', '70%'],
      },
      msgWidths: {
        1: ['40%', '44px'],
        2: ['55%', '36px'],
        3: ['35%', '48px'],
        4: ['45%', '40px'],
        5: ['30%', '52px'],
        6: ['50%', '38px'],
      }
    };
  }
}
</script>

<style lang="scss" scoped>
.chat-skeleton {
  display: flex;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  margin-top: 10px;
  overflow: hidden;
  flex: 1;
  min-height: 0;
}

.chat-skeleton__sidebar {
  width: 300px;
  border-right: 1px solid #e2e8f0;
  background: #f8fafc;
  flex-shrink: 0;
  padding-top: 8px;
}

.chat-skeleton__search {
  padding: 8px 12px 12px;
}

.chat-skeleton__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.chat-skeleton__header {
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.chat-skeleton__messages {
  flex: 1;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.chat-skeleton__msg {
  display: flex;
  align-items: flex-end;
  gap: 8px;

  &--right {
    justify-content: flex-end;
  }
}

.chat-skeleton__footer {
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

@media (max-width: 768px) {
  .chat-skeleton__sidebar {
    display: none;
  }
}
</style>
